<div class="fixed inset-0 z-[60] flex items-center justify-center bg-slate-900/50 px-4 py-6" role="dialog" aria-modal="true" aria-labelledby="account-cancel-title">
  <div class="w-full max-w-lg rounded-2xl border border-gray-200 bg-white p-6 shadow-2xl md:p-8">
    <div class="space-y-4">
      <h2 id="account-cancel-title" class="text-gray-900 text-2xl font-extrabold font-['Inter'] leading-8">
        Tem certeza que deseja cancelar sua conta?
      </h2>

      <div class="space-y-3 text-gray-500 text-base font-normal font-['Inter'] leading-relaxed">
        <p>
          Ao cancelar sua conta, você perderá acesso a todos os benefícios do seu plano atual.
        </p>
      </div>

      @if (errorMessage) {
        <p class="rounded-md bg-red-50 px-4 py-3 text-red-700 text-sm font-normal font-['Inter'] leading-relaxed">
          {{ errorMessage }}
        </p>
      }
    </div>

    <div class="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
      <button
        type="button"
        class="inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-5 py-3 text-center text-sm font-medium text-gray-900 hover:bg-gray-50 focus:outline-none focus:ring-4 focus:ring-gray-100 disabled:opacity-50"
        [disabled]="isSaving"
        (click)="cancelled.emit()">
        mudei de ideia
      </button>

      <button
        type="button"
        class="inline-flex w-full justify-center rounded-md bg-red-700 px-5 py-3 text-center text-sm font-medium text-white hover:bg-red-800 focus:outline-none focus:ring-4 focus:ring-red-200 disabled:opacity-50"
        [disabled]="isSaving"
        (click)="confirmed.emit()">
        sim, quero cancelar
      </button>
    </div>
  </div>
</div>
